// API helper backed by the FastAPI backend.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export const MEDIA_BASE = BACKEND_URL;

const TOKEN_KEY = "admin_token";

function authHeaders() {
  return { Authorization: `Bearer ${getToken()}` };
}

// ---- RSVP ----
export async function submitRSVP(payload) {
  const { data } = await axios.post(`${API}/rsvp`, payload);
  return data;
}
export async function getRSVPs() {
  const { data } = await axios.get(`${API}/rsvp`, { headers: authHeaders() });
  return data;
}

// ---- Guestbook ----
export async function getGuestbook() {
  const { data } = await axios.get(`${API}/guestbook`);
  return data;
}
export async function addGuestbookEntry(payload) {
  const { data } = await axios.post(`${API}/guestbook`, payload);
  return data;
}

// ---- Guest lookup ----
export async function lookupGuest(name) {
  const { data } = await axios.get(`${API}/guests/lookup`, { params: { name } });
  return data.matches;
}
export async function adminGetGuests() {
  const { data } = await axios.get(`${API}/admin/guests`, { headers: authHeaders() });
  return data;
}
export async function adminAddGuest(payload) {
  const { data } = await axios.post(`${API}/admin/guests`, payload, { headers: authHeaders() });
  return data;
}
export async function adminDeleteGuest(id) {
  await axios.delete(`${API}/admin/guests/${id}`, { headers: authHeaders() });
}

// ---- Photos ----
export async function uploadPhoto(uploaderName, file, caption = "") {
  const fd = new FormData();
  fd.append("uploader_name", uploaderName);
  fd.append("caption", caption);
  fd.append("file", file);
  const { data } = await axios.post(`${API}/photos`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
export async function getApprovedPhotos() {
  const { data } = await axios.get(`${API}/photos`);
  return data.map((p) => ({ ...p, url: MEDIA_BASE + p.url }));
}
export async function adminGetPhotos() {
  const { data } = await axios.get(`${API}/admin/photos`, { headers: authHeaders() });
  return data.map((p) => ({ ...p, url: MEDIA_BASE + p.url }));
}
export async function adminApprovePhoto(id) {
  await axios.put(`${API}/admin/photos/${id}/approve`, {}, { headers: authHeaders() });
}
export async function adminDeletePhoto(id) {
  await axios.delete(`${API}/admin/photos/${id}`, { headers: authHeaders() });
}

// ---- Admin auth ----
export async function adminLogin(username, password) {
  const { data } = await axios.post(`${API}/admin/login`, { username, password });
  localStorage.setItem(TOKEN_KEY, data.token);
  return data;
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function adminLogout() {
  localStorage.removeItem(TOKEN_KEY);
}
